
import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
// import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import { MainService as md_mainService } from '../../../md/service/main.service';
import { UserlogService } from '../../service/userlog.service';
import { LogService } from '../../../portal/service/log.service';

declare var $: any;
import { session } from '../../../../environments/environment.session'
@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.css']
})
export class RoleComponent implements OnInit {

  checkBoxValue: any = false;
  displayedColumns: any = ['role_cd', 'role_name', 'role_desc', 'role_type', 'res', 'action'];
  type_data: any = []
  party: any = [];
  datasource: any;
  user_id: any;
  index: any;
  Obj: any = {};
  b_acct_id: any = 0;
  erpUser: any;
  le_type: any = []
  allCodeValue: any = [];
  logObj: any = { component: 'ROLE' }
  message: any;

  constructor(private userlog: UserlogService, private spinner: NgxSpinnerService, private mainService: md_mainService, private log: LogService) { }
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  data = [{ id: 1, acct_short_name: 'AC', acct_full_name: 'Account', name: "UTTAM", email: "uttam@infiniseasoft.com", phone_no: "8840753570" }]
  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser)); this.b_acct_id = this.erpUser.b_acct_id

    this.message = "visit on role"
    let resp = await this.userlog.insertLoginInfo(this.message);
    await this.getCurrentResource()
    await this.getcurrentroleswithresources()
    // await this.getAllModules()
  }
  checkCheckBoxvalue() {
    let dummy :any= []
    if (this.checkBoxValue == true) {
      for (let i = 0; i < this.resource.length; i++) {
        dummy.push(this.resource[i]['resource_cd'])
      }
      this.Obj['res'] = dummy
    } else {
      this.Obj['res'] = null
    }
    console.log(this.checkBoxValue, this.Obj)
  }
  list_flag = true
  create_flag = false
  update_flag = false
  open_create() {

    this.list_flag = false
    this.create_flag = true
    this.update_flag = false
  }
  async open_list() {
    this.list_flag = true
    this.create_flag = false
    this.update_flag = false
    await this.getCurrentResource()
    await this.getcurrentroleswithresources()
  }
  async getcurrentroleswithresources() {
    this.spinner.show()
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj['module_cd'] = 'NOC'
    console.log(obj)
    var resp = await this.mainService.getcurrentroleswithresources(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Role With Resources Data Received Successfully " })
      this.spinner.hide()
      // this.current_role = resp['data']
      // this.Obj['c3']=this.current_rol/e.length
      console.log(resp, 'getcurrentroleswithresources:dtls');
      this.datasource = new MatTableDataSource(resp.data);
      this.datasource.paginator = this.paginator.toArray()[0];
      this.datasource.sort = this.sort.toArray()[0];
    } else {
      this.spinner.hide()
      Swal.fire("Error", "..Error while getting  roles", 'error');
    }
  }
  async getAllModules() {
    this.spinner.show()
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    console.log(obj)
    var resp = await this.mainService.getMdModules(JSON.stringify(obj));
    console.log(resp, 'modules');
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Modules Received Successfully " })
      this.spinner.hide()
      // console.log(resp);
      // this.datasource = new MatTableDataSource(resp.data);
      // this.datasource.paginator = this.paginator;
      // this.datasource.sort = this.sort;
    } else {
      this.spinner.hide()
      Swal.fire("Error", "..Error while getting modules", 'error');
    }
  }
  resource: any = []
  async getCurrentResource() {
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    var resp = await this.mainService.getMdResource(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "Module Resources Data Received Successfully " })
      console.log(resp);
      let dummy = []
      for (let i = 0; i < resp['data'].length; i++) {
        if (resp['data'][i]['module_cd'] == 'NOC') {
          resp['data'][i]['desc'] = resp['data'][i]['module_cd'] + " - " + resp['data'][i]['resource_desc']
          dummy.push(resp['data'][i])
        }
      }
      this.resource = dummy
      console.log(this.resource, 'rrrrrrrrrrrrrrrrrr')
    } else {
      this.spinner.hide()
      Swal.fire("Error", "..Error while getting  resource", 'error');
    }
  }


  viewObj = {}
  viewDetails(element: any) {
    this.viewObj = Object.assign({}, element)
    console.log(element)
    $('#B').modal('show');
  }

  changeparty() {
    for (let i = 0; i < this.party.length; i++) {
      if (this.party[i]['party_id'] == this.Obj['party_id']) {
        this.Obj['party_leagal_name'] = this.party[i]['party_leagal_name']
      }
    }
  }

  async refresh() {
    this.Obj = {}
  }

  back() {
    $('.nav-tabs a[href="#tab-7-1"]').tab('show');
    this.Obj = {};
  }

  async open_update(element: any) {
    this.list_flag = false
    this.create_flag = false
    this.update_flag = true

    console.log(element)
    this.spinner.show();
    this.Obj = Object.assign({}, element);
    // await this.set_flag()
    if (element['resource_cd']) {
      this.Obj['res'] = element['resource_cd'].split(',')
    }
    // if (this.Obj['role_type'] == 'Account Admin') {
    //   this.resource2 = this.resource
    // } else {
    //   let dummy = []
    //   for (let i = 0; i < this.resource.length; i++) {
    //     if (this.Obj['module_cd'] == this.resource[i]['module_cd']) {
    //       dummy.push(this.resource[i])
    //     }
    //   }
    //   this.resource2 = dummy
    // }

    // console.log(this.Obj, this.resource2, this.resource)
    // this.check_flag=true
    $('.nav-tabs a[href="#tab-7-3"]').tab('show');
    this.spinner.hide();
  }



  async submit() {
    if (this.Obj['role_cd'] == null || this.Obj['role_cd'] == ''||this.Obj['role_cd'] == undefined  ) {
      Swal.fire("Error", 'Please Enter Role Code', 'error')
    } else if (this.Obj['role_name'] ==null || this.Obj['role_name'] == undefined ||this.Obj['role_name'] == ''   ) {
      Swal.fire('Error', 'Please Enter Role Description', 'error')
    }
    else if (this.Obj['role_desc'] == null || this.Obj['role_desc'] == '' ||this.Obj['role_desc']==undefined) {
      Swal.fire('Error', 'Please Enter Role Description', 'error')
    }
    else if (this.Obj['res']==null || this.Obj['res']==undefined || this.Obj['res'] =='') {
      Swal.fire('Error', 'Please Select Resource', 'error')
    }
    else {
      let dummy = []
      for (let i = 0; i < this.resource.length; i++) {
        for (let j = 0; j < this.Obj['res'].length; j++) {
          if (this.Obj['res'][j] == this.resource[i]['resource_cd']) {
            dummy.push(this.resource[i])
          }
        }
      }
      this.Obj['b_acct_id'] = this.b_acct_id
      this.Obj['life_cycle_status'] = 'GENERATED'
      this.Obj['user_id'] = this.erpUser.le_id
      this.Obj['role_type'] = 'Module Role'
      this.Obj['data'] = dummy
      this.Obj['module_cd'] = 'NOC'
      console.log(this.Obj)
      this.spinner.show()
      var resp = await this.mainService.createMdRole(this.Obj);
      console.log(resp)
      if (resp['error'] == false) {
        this.log.createLog({ ...this.logObj, activity: 'POST', message: "Module Role Created Successfully " })
        // setTimeout(() => {
          await this.getcurrentroleswithresources()
          this.spinner.hide()
          Swal.fire('Success...', 'Created Successfully', 'success')
        // }, 500);
        await this.open_list()
        this.Obj={}
        
      } else {
        this.spinner.hide()
        Swal.fire('Error', 'Error While Creating', 'error')
      }
    }
  }
  async update() {
    if (!this.Obj['role_cd']) {
      this.spinner.hide()
      Swal.fire("Error", 'Please Enter Role Code', 'error')

    } else if (!this.Obj['role_name']) {
      this.spinner.hide()
      Swal.fire('Error', 'Please Enter Role Description', 'error')
    }
    else if (!this.Obj['role_desc']) {
      this.spinner.hide()
      Swal.fire('Error', 'Please Enter Role Description', 'error')
    }
    else if (!this.Obj['res']) {
      this.spinner.hide()
      Swal.fire('Error', 'Please Select Resource', 'error')
    }
    else {
      let dummy = []
      for (let i = 0; i < this.resource.length; i++) {
        for (let j = 0; j < this.Obj['res'].length; j++) {
          if (this.Obj['res'][j] == this.resource[i]['resource_cd']) {
            dummy.push(this.resource[i])
          }
        }
      }
      this.Obj['b_acct_id'] = this.b_acct_id
      this.Obj['life_cycle_status'] = 'GENERATED'
      this.Obj['user_id'] = this.erpUser.le_id
      this.Obj['role_type'] = 'Module Role'
      this.Obj['data'] = dummy
      this.Obj['module_cd'] = 'NOC'
      console.log(this.Obj)
      this.spinner.show()
      var resp = await this.mainService.updateRole(this.Obj);
      console.log(resp)
      if (resp['error'] == false) {
        this.log.createLog({ ...this.logObj, activity: 'PUT', message: "Role Updated Successfully " })
        this.spinner.hide()
        setTimeout(async () => {
          this.spinner.hide()
          Swal.fire('Success...', 'Created Successfully', 'success')
          await this.getcurrentroleswithresources()
        }, 500);
        this.message = "role created Successfully "
        let resp = await this.userlog.insertLoginInfo(this.message);
      } else {
        this.spinner.hide()
        Swal.fire('Error', 'Error While Creating', 'error')
      }
    }

  }

  validate(email: any) {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (reg.test(email) == false) {
      return (false);
    } else {
      return true
    }
  }


  async delete(element: any) {
    console.log(element)
    this.spinner.hide()
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then((result) => {
      if (result.value) {
        this.finaldelete(element)
      }
    })
  }
  async finaldelete(element: any) {
    let obj: any = {}
    obj = Object.assign({}, element)
    obj['b_acct_id'] = this.b_acct_id
    this.spinner.show()
    var resp = await this.mainService.deleteRole(obj)
    console.log(resp)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'DELETE', message: "Module Role Deleted Successfully " })
      this.spinner.hide()
      this.message = "Deleted role "
      let resp = await this.userlog.insertLoginInfo(this.message);
      await this.getcurrentroleswithresources()
      Swal.fire('Success', "Successfully Deleted", 'success')
    } else {
      this.spinner.hide()
      Swal.fire('Error', resp['data'], 'error')
    }
  }
  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }

}
